import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { MenuButtonIcon, SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function MarkDeliveredDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, fetchPos=null, isIcon=false }) {
  const [open, setOpen] = useState(false);
  const [loadingDelivered, setLoadingDelivered] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingDelivered) {
      setOpen(false);
    }
  };

  const markDelivered = async () => {
    setLoadingDelivered(true);
    try {
      let response = await sendRequest(`purchase-orders/confirm-delivery?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingDelivered(false);
    }
  }

  return (
    <Box>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Mark Delivered"}
        text={"Mark Order as Delivered"}
        icon={WarehouseIcon}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingDelivered}
      >
        <CustomDialogTitle
          header={"Mark Order as Delivered"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Did you confirm that the shipment arrived?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingDelivered}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingDelivered}
            text={"Mark Delivered"}
            onClick={() => markDelivered()}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}